export default "<app-create-employer-profile [isEditProfile]=\"true\"></app-create-employer-profile>"